import React from "react";

export default function IconMinus({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="minus_google">
        <path id="Vector" d="M3.33337 8.66634V7.33301H12.6667V8.66634H3.33337Z" fill="currentColor" />
      </g>
    </svg>
  );
}
